import React from 'react';

import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import { ITabHeaderProps } from '../models/ITabHeaderProps.js';
import { TABS_CATEGORY_KEY, TABS_COMPONENT_KEY } from '../Tabs.meta.js';

export class TabHeader extends React.Component<ITabHeaderProps, Record<string, unknown>> {
	tab: any;
	headerRef: HTMLElement | null | undefined;

	constructor(props: ITabHeaderProps) {
		super(props);
	}

	componentDidMount() {
		this.setFocus();
	}

	componentDidUpdate() {
		this.setFocus();
	}

	setFocus() {
		const { isFocused } = this.props;
		if (isFocused && this.headerRef) {
			this.headerRef.focus();
		}
	}

	assignReference = (instance: HTMLElement | null) => {
		const { assignTabReference } = this.props;
		this.headerRef = instance;
		if (assignTabReference) {
			return assignTabReference(instance);
		}
	};

	render() {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { className, children = '', assignTabReference, isFocused, configuration, ...headerProps } = this.props;
		return (
			<div className={className} {...headerProps} ref={this.assignReference}>
				{children}
			</div>
		);
	}
}

export default InjectedStyledComponent(TabHeader, TABS_CATEGORY_KEY, TABS_COMPONENT_KEY, ['tabHeader']);
